"use strict";
exports.__esModule = true;
exports.UserDocument = void 0;
var _1 = require(".");
var auth_1 = require("../auth");
var UserDocument = /** @class */ (function () {
    function UserDocument(id, avatar, first_name, last_name, email, phone, oauth, timezone_name, timezone_offset, date_format, email_verified, has_created_org, orgs, last_login, created_at, updated_at, max_organisations) {
        if (max_organisations === void 0) { max_organisations = 5; }
        this.id = id;
        this.avatar = avatar;
        this.first_name = first_name;
        this.last_name = last_name;
        this.email = email;
        this.phone = phone;
        this.oauth = oauth;
        this.timezone_name = timezone_name;
        this.timezone_offset = timezone_offset;
        this.date_format = date_format;
        this.email_verified = email_verified;
        this.has_created_org = has_created_org;
        this.orgs = orgs;
        this.last_login = last_login;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.max_organisations = max_organisations;
    }
    UserDocument.fromJSON = function (json) {
        var user = new UserDocument('', '', '', '', '', '', [], '', '', '', false, false, [], 0, 0, 0, 5);
        if (json && json.id) {
            user.id = json.id ? json.id : '';
            user.avatar = json.avatar ? json.avatar : '';
            user.first_name = json.first_name ? json.first_name : '';
            user.last_name = json.last_name ? json.last_name : '';
            user.email = json.email ? json.email : '';
            user.phone = json.phone ? json.phone : '';
            user.oauth = json.oauth.length ? json.oauth.map(function (oauth) { return auth_1.Oauth.fromJSON(oauth); }) : [];
            user.timezone_name = json.timezone_name ? json.timezone_name : '';
            user.timezone_offset = json.timezone_offset ? json.timezone_offset : '';
            user.date_format = json.date_format ? json.date_format : '';
            user.email_verified = json.email_verified !== undefined ? json.email_verified : false;
            user.has_created_org = json.has_created_org !== undefined ? json.has_created_org : false;
            user.orgs = json.orgs.length ? json.orgs.map(function (orgs) { return _1.UserOrganisation.fromJSON(orgs); }) : [];
            user.last_login = json.last_login ? json.last_login : 0;
            user.created_at = json.created_at ? json.created_at : 0;
            user.updated_at = json.updated_at ? json.updated_at : 0;
            user.max_organisations = json.max_organisations ? json.max_organisations : 5;
        }
        return user;
    };
    return UserDocument;
}());
exports.UserDocument = UserDocument;
